export class TimepickConfig {
    // 是否显示清除按钮
    allowClear = true;
    // time
    time = new Date();
    // 默认时间
    nzDefaultOpenValue = new Date();
    // 是否展示清除按钮
    nzAllowEmpty = true;
    // 禁用插件
    nzDisabled = false;
    // 没有值的时候显示的内容
    nzPlaceHolder = '请选择时间';
    // 小时选项间隔
    nzHourStep = 1;
    // 分钟选项间隔
    nzMinuteStep = 1;
    // 秒选项间隔
    nzSecondStep = 1;
    // 禁止选择部分小时选项
    nzDisabledHours = [];
    // 禁止选择部分分钟选项
    nzDisabledMinutes = [];
    // 禁止选择部分秒选项
    nzDisabledSeconds = [];
    // 控件大小设置 large  small
    nzSize = '';
    // 展示的时间格式
    nzFormat = 'HH:mm:ss';

    constructor() {

    }
}

